import { DocumentHeader } from "../../components/Seo";
import { YellowButton } from "../../components/UI/Button/button";
import classes from "./404.module.css";
import { useNavigate } from "react-router-dom";
import { Stan_Open_Hands } from "../../constants/stan";

const Error404 = () => {
  let navigate = useNavigate();
  const handleClick = (e) => {
    e.preventDefault();
    navigate("/");
  };
  return (
    <div className={classes.main}>
      <DocumentHeader
        title="Page not found"
        description="This page does not exist. Go back to Awasource to hire verified talent or find your next role."
      />
      <Stan_Open_Hands shirtColor={"#030659"} />
      <h2 className="mt-sm mb-md">Sorry, you&#8217;re in the wrong place</h2>
      <p className="mb-sm t-14">
        This page does not exist. Click below to get back
      </p>
      <YellowButton onClick={handleClick}>Return Home</YellowButton>
    </div>
  );
};

export default Error404;
